export const CALENDAR_CONSTANTS = {
  HOUR_HEIGHT: 60,
  MOBILE_HOUR_HEIGHT: 80,
  TIME_COLUMN_WIDTH: 80,
  HEADER_HEIGHT: 80,
  GRID_SNAP_MINUTES: 15,
  MIN_DURATION_MINUTES: 15,
  DEFAULT_START_HOUR: 6,
  DEFAULT_END_HOUR: 22,
  HIGHLIGHT_DURATION_MS: 3000,
  SCROLL_BEHAVIOR: 'smooth',
};

export const EVENT_VARIANTS = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  LOCKED: 'locked',
  TEMPORARY_LOCK: 'temporary-lock',
  GROUP: 'group',
  FREE: 'free',
  FREE_SELECTED: 'free-selected',
  UNAVAILABLE: 'unavailable',
};

export const DAY_NAMES_PL = ['Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob', 'Nie'];

export const DAY_NAMES_FULL_PL = [
  'Poniedziałek',
  'Wtorek',
  'Środa',
  'Czwartek',
  'Piątek',
  'Sobota',
  'Niedziela',
];

export const MONTH_NAMES_PL = [
  'Stycznia',
  'Lutego',
  'Marca',
  'Kwietnia',
  'Maja',
  'Czerwca',
  'Lipca',
  'Sierpnia',
  'Września',
  'Października',
  'Listopada',
  'Grudnia',
];

export const VIEW_MODES = {
  DAY: 'day',
  WEEK: 'week',
};

export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
};
